import * as z from "zod";

export const updatePosSettings = {
  name: "updatePosSettings" as const,
  input: z.object({
    defaultRestock: z.boolean().optional(),
    sendOnlyCompletionEmail: z.boolean().optional(),
  }),
  output: z.object({}),
};
